var map = {
	"./aws.png": 1605,
	"./css1.png": 1102,
	"./flutter.png": 716,
	"./html1.png": 5806,
	"./js.png": 3913,
	"./js1.png": 4612,
	"./php.png": 9370,
	"./react.png": 51,
	"./reactjs.png": 1294,
	"./tailwind.png": 8456
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5946;